export default __webpack_public_path__ + "static/media/oven-inspection.50aa4856.svg";